export const paymentLabels = {
  heading: 'Based on your credit review. you need to pay a $downPaymentAmt downpayment today to complete your transaction.',
  subHeading: 'By paying this amount upfront, you will receive a $creditAmt credit on your bill for your device payment each month.',
};
